import React from 'react'
import Menu from './Menu.js'
import Grid from "@material-ui/core/Grid";
import '../assets/css/Order.css'
import Table from '../components/Table/ResponseInputTable'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { NavLink } from "react-router-dom";

const useStyles = theme => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            marginBottom: theme.spacing(10)
        }
    },
    back: {
        color: 'red',
        marginTop: '30%'
    },
});

class MyLenders extends React.Component {
    render() {
        const { classes } = this.props;
        return (
            <div style={{ backgroundColor: 'white' }}>
                <div>
                    <Grid container>
                        <Grid item xs={12}>
                            <Menu />
                        </Grid>
                    </Grid>
                </div>
                <div className="mdata">
                    <Grid container >
                        <Grid item xs={12}>
                            <h2 className="mtextOpenOrder">
                                Response Inputs
                            </h2>
                            {/* <NavLink to={ `/MyLenders/products/${this.props.match.params.lenderId}`}> */}
                            <NavLink to={{ 
                                pathname: `/MyLenders/products/${this.props.match.params.lenderId}`, 
                                state: {
                                    lender_name: this.props.location.state.lender_name
                                }
                            }}>
                            <div style={{textAlign: "right"}}>                        
                                <Button disabled variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', 
                                    color: 'white', height: '50px', width: '120px', fontFamily: 'Roboto-Bold', 
                                    backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center', marginBottom: '10px' }} 
                                    >
                                    Back
                                </Button>
                            </div>

                        </NavLink>
                        </Grid>
                    </Grid>
                    <Grid>
                        <Grid item xs={12}>
                            <Table 
                                lenderId={this.props.match.params.lenderId} 
                                productId={this.props.match.params.productId}
                                lenderName={this.props.location.state.lender_name}
                            />
                        </Grid>
                    </Grid>

                    <Grid container justify="center">
                        <Grid item>
                            <div className={classes.root}>
                            {/* <NavLink to={`/MyLenders/products/${this.props.match.params.lenderId}/responseInputs/${this.props.match.params.productId}/add`}> */}
                            <NavLink to={{ 
                                pathname: `/MyLenders/products/${this.props.match.params.lenderId}/responseInputs/${this.props.match.params.productId}/add`, 
                                state: {
                                    lender_name: this.props.location.state.lender_name
                                }
                            }}>
                                <div className={classes.rootButton}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '170px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                    Add Response Input
                                    </Button>
                                </div>
                                </NavLink>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }

}

export default withStyles(useStyles, { withTheme: true })(MyLenders)